// extracted by mini-css-extract-plugin
export default {"adminDashboard":"admin-dashboard_adminDashboard__VG4SR","menu":"admin-dashboard_menu__y8cGm","dashboardContent":"admin-dashboard_dashboardContent__qxco9"};